module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-panel proDetails-panel"
  }, [_c('proHeaders', {
    staticClass: "fixed",
    attrs: {
      "path": _vm.path
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pd30 bg-sec"
  }, [_c('div', {
    staticClass: "pro-img-swiper"
  }, [(_vm.detailImgs.length > 0) ? _c('mt-swipe', {
    attrs: {
      "auto": 3000
    }
  }, _vm._l((_vm.detailImgs), function(imgUrl, index) {
    return _c('mt-swipe-item', {
      key: index,
      staticClass: "pro-slide"
    }, [_c('img', {
      attrs: {
        "src": imgUrl
      }
    })])
  })) : _c('mt-swipe', {
    attrs: {
      "auto": 3000
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/default-pro-big.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "pro-titles"
  }, [_c('h1', [_vm._v(_vm._s(_vm.goodsBean.name))]), _vm._v(" "), (_vm.goodsBean.type != 2) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v("¥"), (_vm.currSkuBean.price) ? _c('span', [_vm._v(_vm._s(_vm._f("filterPrice")(_vm.currSkuBean.price)))]) : _vm._e()]) : _c('p', {
    staticClass: "text-red"
  }, [_vm._v("¥"), (_vm.goodsBean.discountPrice) ? _c('span', [_vm._v(_vm._s(_vm._f("filterPrice")(_vm.goodsBean.discountPrice)))]) : _vm._e()])]), _vm._v(" "), (_vm.goodsBean.type != 2) ? _c('div', {
    staticClass: "pro-spec"
  }, [_c('p', {
    staticClass: "text-grey"
  }, [_vm._v(_vm._s(_vm.skuPropertyName))]), _vm._v(" "), _c('div', {
    staticClass: "spec-list"
  }, _vm._l((_vm.productSkuList), function(item, index) {
    return _c('span', {
      staticClass: "item-spec",
      class: {
        'active': _vm.activeSpec == index
      },
      on: {
        "click": function($event) {
          _vm.getCurrSku(index)
        }
      }
    }, _vm._l((item.skuPropertyValues), function(itemData, index) {
      return _c('span', [_vm._v("\n                    " + _vm._s(itemData) + "\n                   ")])
    }))
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "counter-operate"
  }, [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("选择数量")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "icon-reduce",
    on: {
      "click": _vm.reduce
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-counter"
  }, [_vm._v(_vm._s(_vm.counter))]), _vm._v(" "), _c('span', {
    staticClass: "icon-plus",
    on: {
      "click": _vm.plus
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pro-help"
  }, [_c('span', {
    staticClass: "item-help",
    on: {
      "click": function($event) {
        _vm.promiseShow = true
      }
    }
  }, [_vm._v("幸福承诺")]), _c('span', {
    staticClass: "item-help"
  }, [_c('router-link', {
    attrs: {
      "to": "/deliveryArea"
    }
  }, [_vm._v("查看配送区域")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pd30 bg-sec"
  }, [_c('div', {
    staticClass: "pro-details"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("产品详情")]), _vm._v(" "), _c('div', {
    staticClass: "pro-details-info",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlProdetails)
    }
  })])]), _vm._v(" "), (_vm.goodsBean.saleStatus == 2) ? _c('div', {
    staticClass: "pro-footer"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('p', {
    staticClass: "up-count"
  }, [_vm._v("+" + _vm._s(_vm.counter))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "i-cart",
    on: {
      "click": function($event) {
        _vm.submitLoading && _vm.addToCart()
      }
    }
  }, [_vm._v("加入购物车")]), _vm._v(" "), _c('span', {
    staticClass: "i-buynow",
    on: {
      "click": function($event) {
        _vm.submitLoading && _vm.checkOut()
      }
    }
  }, [_vm._v("立即购买")])], 1) : _vm._e(), _vm._v(" "), (_vm.goodsBean.saleStatus == 1) ? _c('div', {
    staticClass: "pro-footer"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('p', {
    staticClass: "up-count"
  }, [_vm._v("+" + _vm._s(_vm.counter))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "i-cart i-disabled"
  }, [_vm._v("已下架")])], 1) : _vm._e(), _vm._v(" "), _c('mt-popup', {
    staticClass: "promise-popup",
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.promiseShow),
      callback: function($$v) {
        _vm.promiseShow = $$v
      },
      expression: "promiseShow"
    }
  }, [_c('span', {
    staticClass: "promise-btn",
    on: {
      "click": function($event) {
        _vm.promiseShow = false
      }
    }
  }, [_vm._v("我知道了")]), _vm._v(" "), _c('div', {
    staticClass: "promise-sec"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("幸福承诺")]), _vm._v(" "), _c('p', {
    staticClass: "promise-line"
  }, [_c('span', {
    staticClass: "i-b"
  }, [_vm._v("就敢退")]), _vm._v(" 实物不对版，退款不退货！")]), _vm._v(" "), _c('p', {
    staticClass: "promise-line"
  }, [_c('span', {
    staticClass: "i-b"
  }, [_vm._v("就敢减")]), _vm._v(" 约定时间！迟到1分钟减1元！")]), _vm._v(" "), _c('p', {
    staticClass: "promise-line"
  }, [_c('span', {
    staticClass: "i-b"
  }, [_vm._v("就敢送")]), _vm._v(" 迟到30分钟免费赠送！")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07d15ef5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/productDetail/productDetail.vue
// module id = 547
// module chunks = 1